
































































































































































































































































































import {
	GroupByProjectionDefinition,
	ProjectionAggregationEnum,
	QueryOperator, ShareModel, SortOrder,
	TransactionModel,
	WalletModel,
	WalletTransactionModel,
	WalletTransactionTypeEnum
} from '@/libs/Api';
import {Component, Ref, Watch} from 'vue-property-decorator';
import {CrudAction} from '@/libs/core/crud/crud-action';
import {createCrudQueryPayload, createGroupedQueryPayload, CrudQueryPredicate} from '@/libs/core/crud/crud-query';
import {CrudGetter} from '@/libs/core/crud/crud-getter';

import CrudTable from '@/libs/common/components/CrudTable.vue';
import {Guid} from '@/libs/common/functions/guid';
import {Constants} from '@/libs/constants/constants';
import {walletTransactionsStore} from '@/libs/wallet-transactions/+state/store';
import Page from '@/Page.vue';
import {walletsStore} from '@/libs/wallets/+state/store';
import ApiService from '@/libs/core/api-service';
import {CrudPageInfo} from '@/libs/core/crud/crud-store-state';
import {sharesStore} from '@/libs/shares/+state/store';

@Component({
	components: {
		CrudTable
	}
})
export default class ProductNremERewards extends Page {

	headers = [
		{ text: 'Klient', align: 'left', sortable: false, value: 'wallet.partyProduct.party.displayName', type: "text", width: "20%" },
		{ text: 'Typ', align: 'left', sortable: false, value: 'type', type: "text", width: "10%" },
		{ text: 'Částka', align: 'left', sortable: false, value: 'amount', suffix: "CP", type: "number", width: "10%" },
		{ text: 'Datum', align: 'left', sortable: false, value: 'time', type: "datetime" },
		{ text: 'Zadáno uživatelem', align: 'left', sortable: false, value: 'createdBy.displayName', type: "datetime" }
	];

	clientId: string | null = null;
	since: string | null = null;
	until: string | null = null;
	showFilters = false;
	productId = Constants.NremEProductId;
	isDeposit = false;
	walletCannotBeFound = false;
	partyProductId = null;
	amount = null;
	onlyDeposit = 0;
	wallets: WalletModel[];
	partyWalletIm4: WalletModel = null;
	basicRules = [
		(v: any) => !!v || 'Toto pole je povinné.'
	];
	basicRulesWithoutDecimal = [
		(v: any) => !!v || 'Toto pole je povinné.',
		(v: any) => (!!v && Number(v) % 1 == 0) || 'Zadaný počet CP nesmí být desetinné číslo'
	];
	selectedShareType = 0;
	selectedShares: ShareModel[] = [];
	searchEvidenceNumberFrom: number | null = null;
	searchEvidenceNumberTo: number | null = null;
	foundShares: number | null = null;
	sharesToBuySearch = "";
	sharesToBuyDebounce: any = null;
	foundSharesToSellCount: number | null = null;
	foundSharesToBuyCount: number | null = null;

	pageIndex = 1;
	pageSize = 50;
	totalFreeShares = 0;

	@Ref() crudTable!: CrudTable;

	@Watch("clientId")
	@Watch("since")
	@Watch("until")
	@Watch("onlyDeposit")
	filtersChanged(): void {
		this.loadData();
	}

	@Watch("pageIndex")
	@Watch("pageSize")
	paginationChanged() {
		this.loadData();
	}

	@Watch("partyProductId")
	partyProductIdChanged(v: string | null, p: string | null) {
		if (v != null && v != p) {
			this.selectedShareType = 0;
			this.selectedShares = [];
			this.getWallets();
			this.getSharesToBuy();
			this.getSharesToSell();
		}
	}

	@Watch("isSaving")
	isSavingChanged(current: boolean, prev: boolean) {
		if (!current && prev) {
			this.crudTable.close();
			this.loadGroupedData();
		}
	}

	@Watch("isDeleting")
	isDeletingChanged(current: boolean, prev: boolean) {
		if (!current && prev) {
			this.crudTable.closeDelete();
			this.loadGroupedData();
		}
	}

	get items(): any[] {
		const items = [...walletTransactionsStore.useGetter(CrudGetter.Data)];
		return items.select((x) => {
			const e = {...x};
			e.type = e.amount > 0 ? "Přidání odměny" : "Odebrání odměny";
			return e;
		}).toArray();
	}

	get walletSum(): number {
		const transactions = walletTransactionsStore.useGetter(CrudGetter.Data) as WalletTransactionModel[];
		return transactions.select(x => x.amount).sum();
	}

	get groupedData(): any {
		const data = walletTransactionsStore.useGetter(CrudGetter.GroupedData, 'TotalAmount');
		return data && data?.length > 0 ? data[0] : null;
	}

	get groupedDataDeposit(): any {
		const data = walletTransactionsStore.useGetter(CrudGetter.GroupedData, 'AmountDeposit');
		return data && data?.length > 0 ? data[0] : null;
	}

	get groupedDataWithdrawal(): any {
		const data = walletTransactionsStore.useGetter(CrudGetter.GroupedData, 'AmountWithdrawal');
		return data && data?.length > 0 ? data[0] : null;
	}

	get totalRows (): number {
		return ({...walletTransactionsStore.useGetter(CrudGetter.PageInfo)} as CrudPageInfo)?.rowCount;
	}

	get isMobile(): boolean {
		return window.outerWidth <= 1140;
	}

	get isSaving(): boolean {
		return walletTransactionsStore.useGetter(CrudGetter.Saving);
	}

	get isDeleting(): boolean {
		return walletTransactionsStore.useGetter(CrudGetter.Deleting);
	}

	get sharesToBuy(): ShareModel[] {
		return sharesStore.useGetter(CrudGetter.Data, 'SharesToBuy') ?? [];
	}

	get isSearchingSharesToBuy(): boolean {
		return sharesStore.useGetter(CrudGetter.Pending, 'SearchShares');
	}

	get sharesToSell(): ShareModel[] {
		return sharesStore.useGetter(CrudGetter.Data, 'SharesToSell') ?? [];
	}

	get isSearchingSharesToSell(): boolean {
		return sharesStore.useGetter(CrudGetter.Pending, 'SearchSharedToSell');
	}

	@Watch("selectedShares")
	selectedSharesChanged(v: ShareModel[]) {
		this.amount = v?.length ?? 0;
	}

	@Watch("sharesToBuySearch")
	sharesToBuySearchChanged(v: string, p: string) {
		clearTimeout(this.sharesToBuyDebounce);
		this.sharesToBuyDebounce = setTimeout(() => {
			this.getSharesToBuy();
		}, 500);
	}

	mounted(): void {
		this.loadData();
	}

	loadData(): void {
		let filters: CrudQueryPredicate[] = [
			{ field: "wallet.partyProduct.productId", op: "eq", comparand: Constants.NremEProductId },
			{ field: "wallet.currencyId", op: "eq", comparand: Constants.CurrencyNremEId },
			{ field: "tradeId", op: "eq", comparand: null }
		];
		filters = filters.concat(this.getFilters());
		walletTransactionsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WalletTransactionModel>([ { field: "time", index: 1, order: "desc" } ], filters, { pageIndex: this.pageIndex, pageSize: this.pageSize }));
		this.loadGroupedData();
	}

	getFilters(): CrudQueryPredicate[] {
		let filters: CrudQueryPredicate[] = [];
		if (this.clientId) {
			filters.push({ field: "wallet.partyProduct.partyId", op: "eq", comparand: this.clientId });
		}
		if (this.since) {
			filters.push({ field: "time", op: "gte", comparand: this.since });
		}
		if (this.until) {
			filters.push({ field: "time", op: "lte", comparand: this.until });
		}
		if (this.onlyDeposit > 0) {
			filters.push({ field: "amount", op: this.onlyDeposit == 1 ? 'gt' : 'lt', comparand: 0 });
		}
		return filters;
	}

	addDepositClick(): void {
		this.partyWalletIm4 = null;
		this.isDeposit = true;
		this.crudTable.addItemClick();
		this.getTotalFreeShares();
	}

	addWithdrawalClick(): void {
		this.partyWalletIm4 = null;
		this.isDeposit = false;
		this.crudTable.addItemClick();
	}

	getSharesToBuy(): Promise<number | null> {
		return new Promise<number | null>((resolve, reject) => {
			const predicates: CrudQueryPredicate[] = [
				{ field: 'productId', op: QueryOperator.Eq, comparand: Constants.NremEProductId },
				{ field: 'ownerId', op: QueryOperator.Eq, comparand: null }
			];
			if (this.sharesToBuySearch && !isNaN(Number(this.sharesToBuySearch))) {
				predicates.push({
					field: 'evidenceNumber',
					op: QueryOperator.Gte,
					comparand: Number(this.sharesToBuySearch) - 2
				});
			}
			sharesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ShareModel>({ field: 'evidenceNumber', index: 1, order: SortOrder.Asc }, predicates, { pageIndex: 1, pageSize: 10 }, false, 'SharesToBuy'))
		});
	}

	getSharesToSell(): Promise<number | null> {
		return new Promise<number | null>((resolve, reject) => {
			sharesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ShareModel>({ field: 'evidenceNumber', index: 1, order: SortOrder.Asc }, [
				{ field: 'ownerId', op: QueryOperator.Eq, comparand: this.partyProductId ?? Guid.EmptyGuid() }
			], undefined, false, 'SharesToSell'))
		});
	}

	saveItem(e: WalletTransactionModel): void {
		if (this.isDeposit && Number(this.amount) > Number(this.totalFreeShares)) {
			return;
		}
		if (!this.isDeposit && this.partyWalletIm4 != null && this.partyWalletIm4.currentValue < this.amount) {
			return;
		}
		this.walletCannotBeFound = false;
		walletsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WalletModel>(undefined, [
			{ field: 'partyProductId', op: 'eq', comparand: this.partyProductId },
			{ field: 'currencyId', op: 'eq', comparand: Constants.CurrencyNremEId },
		], { pageSize: 1, pageIndex: 1 }, false, 'LoadWallet'));
		this.subscribe(walletsStore, CrudAction.GetAll, 'LoadWallet').then((wallets: WalletModel[]) => {
			if (wallets.any()) {
				e.amount = Math.abs(this.amount) * (this.isDeposit ? 1 : -1);
				e.shares = this.selectedShares?.map(x => x.id) ?? [];
				if (e.id == Guid.EmptyGuid() || e.id == null) {
					e.walletId = wallets.first().id;
					walletTransactionsStore.dispatch(CrudAction.Create, { item: e });
				}
				else {
					walletTransactionsStore.dispatch(CrudAction.Update, { item: e });
				}
			}
			else {
				this.walletCannotBeFound = true;
			}
			this.loadGroupedData();
		});
	}

	deleteItem(e: WalletTransactionModel): void {
		walletTransactionsStore.dispatch(CrudAction.Delete, createCrudQueryPayload<TransactionModel>(undefined, [ { field: "id", op: "eq", comparand: e.id! } ]));
	}

	beforeAdd(e: WalletTransactionModel): void {
		e.transactionType = WalletTransactionTypeEnum.Reward;
		this.amount = 0;
		this.partyProductId = null;
	}

	beforeEdit(e: WalletTransactionModel): void {
		this.isDeposit = e.amount >= 0;
		this.amount = Math.abs(e.amount);
		this.partyProductId = e.wallet.partyProductId;
	}

	getWallets(): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			ApiService.api.getWalletBatch(1, 99, {
				predicates: [
					{ field: 'partyProductId', op: QueryOperator.Eq, comparand: this.partyProductId }
				]
			}).then((e: any) => {
				this.wallets = e.data.returnValue.items;
				this.partyWalletIm4 = this.wallets.firstOrDefault(x => x.currencyId == Constants.CurrencyNremEId && x.partyProductId == this.partyProductId);
				resolve(this.wallets);
			}).catch((e: any) => reject(e));
		});
	}

	loadGroupedData() {
		walletTransactionsStore.dispatch(CrudAction.GetGrouped, createGroupedQueryPayload<WalletTransactionModel>([
			{ field: 'wallet.currencyId', op: QueryOperator.Eq, comparand: Constants.CurrencyNremEId },
			{ field: 'transactionType', op: QueryOperator.Eq, comparand: WalletTransactionTypeEnum.Reward },
			{ field: 'wallet.partyProduct.productId', op: QueryOperator.Eq, comparand: Constants.NremEProductId },
			{ field: 'tradeId', op: QueryOperator.Eq, comparand: null },
			{ field: 'amount', op: QueryOperator.Gt, comparand: 0 }
		].concat(this.getFilters() as any), [], [
			{
				field: "amount",
				aggregation: ProjectionAggregationEnum.Sum,
				outputField: "amount"
			} as GroupByProjectionDefinition
		], 'AmountDeposit'));
		walletTransactionsStore.dispatch(CrudAction.GetGrouped, createGroupedQueryPayload<WalletTransactionModel>([
			{ field: 'wallet.currencyId', op: QueryOperator.Eq, comparand: Constants.CurrencyNremEId },
			{ field: 'transactionType', op: QueryOperator.Eq, comparand: WalletTransactionTypeEnum.Reward },
			{ field: 'wallet.partyProduct.productId', op: QueryOperator.Eq, comparand: Constants.NremEProductId },
			{ field: 'tradeId', op: QueryOperator.Eq, comparand: null },
			{ field: 'amount', op: QueryOperator.Lt, comparand: 0 }
		].concat(this.getFilters() as any), [], [
			{
				field: "amount",
				aggregation: ProjectionAggregationEnum.Sum,
				outputField: "amount"
			} as GroupByProjectionDefinition
		], 'AmountWithdrawal'));
	}

	getTotalFreeShares(): Promise<number | null> {
		return new Promise<number | null>((resolve, reject) => {
			ApiService.api.getShareGroupped({
				predicates: [
					{ field: 'productId', op: QueryOperator.Eq, comparand: Constants.NremEProductId },
					{ field: 'ownerId', op: QueryOperator.Eq, comparand: null }
				],
				groupby: [],
				projections: [
					{
						field: "id",
						aggregation: ProjectionAggregationEnum.Count,
						outputField: "count"
					} as GroupByProjectionDefinition
				]
			}).then((e) => {
				this.totalFreeShares = e.data.returnValue.firstOrDefault()?.count;
				resolve(this.totalFreeShares);
			}).catch((e: any) => reject(e));
		});
	}

	searchShareInterval() {
		this.foundShares = null;
		sharesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ShareModel>({ field: 'evidenceNumber', index: 1, order: SortOrder.Asc }, [
			{ field: 'productId', op: QueryOperator.Eq, comparand: this.productId! },
			{ field: 'ownerId', op: QueryOperator.Eq, comparand: this.isDeposit ? null : this.clientId },
			{ field: 'evidenceNumber', op: QueryOperator.Gte, comparand: Number(this.searchEvidenceNumberFrom) },
			{ field: 'evidenceNumber', op: QueryOperator.Lte, comparand: Number(this.searchEvidenceNumberTo) }
		], undefined, false, 'SearchShares'));
		this.subscribe(sharesStore, CrudAction.GetAll, 'SearchShares').then((e: ShareModel[]) => {
			this.foundShares = e.length;
			this.foundSharesToBuyCount = e.length;
			this.selectedShares = [...e];
			this.selectedSharesChanged(this.selectedShares);
		});
	}

	searchSharedToSell() {
		this.foundSharesToSellCount = null;
		sharesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ShareModel>({ field: 'evidenceNumber', index: 1, order: SortOrder.Asc }, [
			{ field: 'productId', op: QueryOperator.Eq, comparand: this.productId! },
			{ field: 'ownerId', op: QueryOperator.Eq, comparand: this.partyProductId! },
			{ field: 'evidenceNumber', op: QueryOperator.Gte, comparand: Number(this.searchEvidenceNumberFrom) },
			{ field: 'evidenceNumber', op: QueryOperator.Lte, comparand: Number(this.searchEvidenceNumberTo) }
		], undefined, false, 'SearchSharedToSell'));
		this.subscribe(sharesStore, CrudAction.GetAll, 'SearchSharedToSell').then((e: ShareModel[]) => {
			this.foundSharesToSellCount = e.length;
			this.selectedShares = [...e];
			this.selectedSharesChanged(this.selectedShares);
		});
	}

	clearSelectedShared() {
		this.selectedShares = [];
		this.selectedSharesChanged(this.selectedShares);
		this.searchEvidenceNumberFrom = null;
		this.searchEvidenceNumberTo = null;
		this.foundSharesToSellCount = null;
		this.foundSharesToBuyCount = null;
		this.foundShares = null;
	}

}
